package pl.finn.forms.common

import io.kvision.html.Div
import pl.finn.forms.fk02.DynamicFieldsValidator

import io.kvision.form.*
import io.kvision.html.*
import io.kvision.panel.FieldsetPanel

class BlockList(dfv: DynamicFieldsValidator) {

  private val dynamicFieldsValidator = dfv

  fun <T> generateModifiableList(
    elementsList:  ArrayList<T>,
    elementView: (T, String?) -> FieldsetPanel,
    elementType: () -> T,
    elementsListName: String? = null,
    elementsName: (String?) -> String?,
    firstElementObligatory: Boolean = false
  ): FieldsetPanel {
    val div = FieldsetPanel(elementsListName)
    if(firstElementObligatory){
      if (elementsList != null && elementsList.isEmpty()) {
        elementsList.add(elementType())
      }
    }
    if (elementsList != null && !elementsList.isEmpty()) {
      div.apply {
        var iter = 0
        elementsList.forEach { element ->
          iter+=1
          add(
            elementView(element, elementsName(iter.toString()))
          )
        }
      }
    }
    div.addAll(createButtons(elementsList, div, elementView, elementType, elementsName, firstElementObligatory).getChildren())
    return div
  }

  private fun <T> createButtons(
    elementsList: ArrayList<T>,
    div: FieldsetPanel, elementView: (T, String?) -> FieldsetPanel,
    elementType: () -> T,
    elementsName: (String?) -> String?,
    firstElementObligatory: Boolean
  ): Div {
    return Div(className = "p-2 d-flow-root") {
      button(
        "Usuń",
        "far fa-minus-square",
        ButtonStyle.OUTLINEPRIMARY, className = "btn-sm"
      ).apply {
        visible = elementsList != null && elementsList.size > (if(firstElementObligatory) 1 else 0)
      }.onClick {
        if (elementsList != null && elementsList.size > 0) {
          elementsList.removeLast()
          dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
          div.removeAll()
          if (!elementsList.isEmpty()) {
            div.apply {
              var iter = 0
              elementsList.forEach { element ->
                iter+=1
                add(
                  elementView(element, elementsName(iter.toString()))
                )
              }
            }
          }
          div.addAll(createButtons(elementsList, div, elementView, elementType, elementsName, firstElementObligatory).getChildren())
        }
      }
      button(
        "Dodaj",
        "far fa-plus-square",
        ButtonStyle.OUTLINEPRIMARY, className = "btn-sm float-right"
      ).onClick {
        if (elementsList != null) {
          elementsList.add(elementType())
          dynamicFieldsValidator.removeAll(div.getChildren() as List<FormControl>)
          div.removeAll()
          div.apply {
            var iter = 0
            elementsList.forEach { element ->
              iter+=1
              add(
                elementView(element, elementsName(iter.toString()))
              )
            }
          }
          div.addAll(createButtons(elementsList, div, elementView, elementType, elementsName, firstElementObligatory).getChildren())
        }
      }
    }
  }

}